/*******************************************
 * All Animations *
 * We are using Greensock to handle our animation JS *
 *greensock.com/docs*
 *******************************************/
 jQuery(document).ready(function($) {

    $('.site').css('opacity', 1);
    $('.wiper-shade').removeClass('animate');


    var headlineCount = $('.home-hero-headline').length;

    function animateItems() {
        $('.home-hero-headline').each(function(index) {
            var $this = $(this);
            setTimeout(function() {
                $this.addClass('animate');
                $('.home-hero-headline').not($this).removeClass('animate');
            }, 6000 * index);
        });
    }

    setInterval(animateItems, 6000 * headlineCount);

    animateItems();

    // create the scrollSmoother before your scrollTriggers
    ScrollSmoother.create({
        smooth: 2,               // how long (in seconds) it takes to "catch up" to the native scroll position
        effects: true,           // looks for data-speed and data-lag attributes on elements
        smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    });

    const title = document.querySelector('.inner-hero .page-title h1');

    if (title) { // check if the element exists
        const beforeBorder = getComputedStyle(title, '::before');

        const tl = gsap.timeline();

        tl
        // Animate the ::before border from 0 to full height
        .from(title, {
            '--border-height': '0',
            duration: parseFloat(beforeBorder.getPropertyValue('--border-duration')),
            ease: 'power3.in',
            onUpdate: function() {
            title.style.setProperty('--border-height', title.style.getPropertyValue('--border-height'));
            }
        })
        // Animate the h1 from left to right
        .to(title, {
            duration: .5,
            ease: 'power3.out',
            opacity: 1,
            x: 0,
        })
        // Animate the ::before border from full height to 0
        .to(title, {
            '--border-height': '100%',
            duration: parseFloat(beforeBorder.getPropertyValue('--border-duration')),
            ease: 'power3.out',
            onUpdate: function() {
            title.style.setProperty('--border-height', title.style.getPropertyValue('--border-height'));
            }
        })
        // Animate the .content-wrap
        .from('.hero-content .content-wrap', {
            duration: .25,
            ease: 'power3.out',
            opacity: 0,
            y: 100,
        });

    }


    //hero image
    const heroImg = document.querySelectorAll('.inner-hero .img-wrap, .project-hero .img-wrap');
    heroImg.forEach(heroImg => {
        const imgContainer = heroImg.querySelector('.parallax-wrap');
        const blockTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: heroImg,
            start: '-100% top',
            end: 'bottom center',
            scrub: true,
            }
        })
        .to(imgContainer, {
            y: () => -(window.innerHeight / 10),
            ease: 'none',
        });
    });


    
    //Flex Field ANIMATIONS
    const basicContent = document.querySelectorAll(".basic-content");
        basicContent.forEach(basicContent => {
        const blockTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.basic-content',
                start:'-200 center',
                end:'bottom',
                toggleActions: "play none none none",
            }
        })
        .from(basicContent.querySelectorAll(".container > h2, .container > .content"), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
        })
    });

    const tabbedContent = document.querySelectorAll(".tabbed-content");
    tabbedContent.forEach(tabbedContent => {
        const blockTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.tabbed-content',
                start:'-200 center',
                end:'bottom',
                toggleActions: "play none none none",
            }
        })
        .from(tabbedContent.querySelectorAll(".container > h2"), {
            duration: .5,
            y: 40,
            opacity: 0,
            stagger: .25,
        })
        .from(tabbedContent.querySelectorAll(".container > .tab-container"), {
            duration: .5,
            opacity: 0,
            stagger: .25,
        })

    });


    // //Img with text RIGHT
    const contentImageElementsRight = document.querySelectorAll('.image-with-content.align-right');

    contentImageElementsRight.forEach(contentImageElementsRight => {
        const timeline = new TimelineMax({
            scrollTrigger: {
                trigger: contentImageElementsRight,
                start: "-200 center",
                end: "bottom",
                toggleActions: "play none none none"
            }
        });
        const contentWrap = contentImageElementsRight.querySelectorAll('.content-wrap');
        //Need to reverse the animation to make up for left/right stuff
        for (let i = contentWrap.length - 1; i >= 0; i--) {
            const childElements = [...contentWrap[i].querySelectorAll('.content, .img-wrap')];

            timeline.fromTo(childElements, 0.5, {
                y: -40,
                opacity: 0,
                transformOrigin: "50% 50%",
            }, {
                y: 0,
                opacity: 1,
                stagger: -0.5 // negative stagger value to animate in reverse order
            }, "+=0.25"); // add a delay of 0.25 seconds after animating header
        }
    });
    //Img with text LEFT
    const contentImageElementsLeft = document.querySelectorAll('.image-with-content.align-left');

    contentImageElementsLeft.forEach(contentImageElementsLeft => {
        const timeline = new TimelineMax({
            scrollTrigger: {
                trigger: contentImageElementsLeft,
                start: "-200 center",
                end: "bottom",
                toggleActions: "play none none none"
            }
        });
        const contentWrap = contentImageElementsLeft.querySelectorAll('.content-wrap');

        contentWrap.forEach(contentWrap => {
            const childElements = [...contentWrap.querySelectorAll('.img-wrap, .content')];

            timeline.fromTo(childElements, 0.5, {
                y: -40,
                opacity: 0,
                transformOrigin: "50% 50%",
            }, {
                y: 0,
                opacity: 1,
                stagger: 0.5
            }, "+=0.25"); // add a delay of 0.25 seconds after animating header
        });
    });
    // //Parralax image with text
    const imageContainers = document.querySelectorAll('.image-with-content');
    imageContainers.forEach(imageContainer => {
        const image = imageContainer.querySelector('.container .content-wrap .img-wrap img');
        const blockTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: imageContainer,
                start: '-100% center',
                end: 'bottom',
                scrub: true,
                direction: 1 // reverse direction
            }
        })
        .to(image, {
            y: () => -100,
            ease: 'none',
        });
    });


        //Background Image with image with text
        const contentImageElementsBG = document.querySelectorAll('.image-with-content.align-background');

        contentImageElementsBG.forEach(contentImageElementsBG => {
            const timeline = new TimelineMax({
                scrollTrigger: {
                    trigger: contentImageElementsBG,
                    start: "-100% center",
                    end: "bottom",
                    toggleActions: "play none none none"
                }
            });
            const contentWrap = contentImageElementsBG.querySelectorAll('.content-wrap');

            contentWrap.forEach(contentWrap => {
                const childElements = [...contentWrap.querySelectorAll('.content > *')];

                timeline.fromTo(childElements, 0.4, {
                    y: -40,
                    opacity: 0,
                    transformOrigin: "50% 50%",
                }, {
                    y: 0,
                    opacity: 1,
                    stagger: 0.25
                }, "+=0.25"); // add a delay of 0.25 seconds after animating header
            });
        });


    //Testimonal Sliders
    const testimonials = document.querySelectorAll(".testimonials");

        testimonials.forEach((testimonial) => {
        const timeline = gsap.timeline({
            scrollTrigger: {
            trigger: testimonial,
            start: "-200 center",
            end: "bottom",
            toggleActions: "play none none none",
            },
        });

        const testHeader = testimonial.querySelector(".header");
        const testheaderElements = testHeader.querySelectorAll("h2, .content");

        timeline
            // Animate the header
            .from(testheaderElements, {
            duration: 0.5,
            y: 40,
            opacity: 0,
            stagger: 0.25,
            });
    });




    //People
    const expertSection = document.querySelectorAll(".experts");

    expertSection.forEach((expertSection) => {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: expertSection,
                start: "-200 center",
                end: "bottom",
                toggleActions: "play none none none",
            },
        });

        const header = expertSection.querySelector("h2");

        timeline
            // Animate the header
            .from(header, {
                duration: 0.5,
                y: 40,
                opacity: 0,
                stagger: 0.25,
            });

        const expertItems = expertSection.querySelectorAll(".team-wrap .team-member-cards");

        expertItems.forEach((expertItem) => {
            const expertCards = expertItem.querySelectorAll(".team-card");
            const cardElements = expertItem.querySelectorAll(".team-card .member-photo, .member-details > *");

            // Animate the card container
            timeline.fromTo(expertItem, {
                y: -40,
                opacity: 0,
            }, {
                duration: 0.5,
                y: 0,
                opacity: 1,
                stagger: 0.08,
                transformOrigin: "50% 50%",
            }, 0);

            // Animate the cards
            expertCards.forEach((expertCard) => {
                timeline.fromTo(expertCard, {
                    y: -40,
                    opacity: 0,
                }, {
                    duration: 0.5,
                    y: 0,
                    opacity: 1,
                    stagger: 0.08,
                    transformOrigin: "50% 50%",
                }, "-=0.25");
            });
        });
    });

    //Icon Callouts
    const iconCallouts = document.querySelectorAll(".callouts");

    iconCallouts.forEach((iconCallout) => {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: iconCallout,
                start: "-200 center",
                end: "bottom",
                toggleActions: "play none none none",
            },
        });

        const header = iconCallout.querySelector(".callout-header");
        const headerElements = header.querySelectorAll("h2, .content");

        timeline
            // Animate the header
            .from(headerElements, {
                duration: 0.5,
                y: 40,
                opacity: 0,
                stagger: 0.25,
            });

        const items = iconCallout.querySelectorAll(".callout-wrap");

        items.forEach((item) => {
            const cards = item.querySelectorAll(".callout");
            const cardElements = item.querySelectorAll(".callout img, .callout h3, .callout div");

            // Animate the card container
            timeline.from(item, {
                duration: 0.5,
                y: -40,
                opacity: 0,
                stagger: 0.08,
                transformOrigin: "50% 50%",
            }, 0);

            // Animate the cards
            cards.forEach((card) => {
                timeline.from(card, {
                    duration: 0.5,
                    y: -40,
                    opacity: 0,
                    stagger: 0.08,
                    transformOrigin: "50% 50%",
                }, 0)
            });

            // Animate the child elements
            const childElements = item.querySelectorAll(".callout img, .callout h3, .callout div");

            timeline.from(childElements, {
                duration: 0.5,
                y: -40,
                opacity: 0,
                stagger: 0.08,
                transformOrigin: "50% 50%",
            }, "-=0.25");
        });
    });

    //Bids
    const bids = document.querySelectorAll(".bids");

    bids.forEach(bid => {
        const timeline = new TimelineMax({
            scrollTrigger: {
            trigger: bid,
            start: "-200 center",
            end: "bottom",
            toggleActions: "play none none none"
            }
        });

        const headerElements = bid.querySelectorAll("h2");

        timeline.from(headerElements, 0.5, {
            y: 40,
            opacity: 0,
            stagger: 0.25
        });

        const contentWrapElements = bid.querySelectorAll('.content-wrap');

        contentWrapElements.forEach(contentWrap => {
            const childElements = [...contentWrap.querySelectorAll('.content, .iframe-wrap')];

            timeline.fromTo(childElements, 0.5, {
                y: -40,
                opacity: 0,
                transformOrigin: "50% 50%",
            }, {
                y: 0,
                opacity: 1,
                stagger: 0.25
            }, "+=0.25"); // add a delay of 0.25 seconds after animating header
        });
    });

    //Slider
    const slider = document.querySelectorAll(".slider");

     slider.forEach(slider => {
        const timeline = new TimelineMax({
            scrollTrigger: {
            trigger: slider,
            start: "-200 center",
            end: "bottom",
            toggleActions: "play none none none"
            }
        });
 
        const headerElements = slider.querySelectorAll(".container.slider-heading h2, .container.slider-heading .content");
 
        timeline.from(headerElements, 0.5, {
             y: 40,
             opacity: 0,
             stagger: 0.25
        });
    });

    //Project Cards
    // select all project card wrappers
    const projectCardWrapperOne = document.querySelectorAll('.projects-layout-one .masonry-projects');
    // loop through each project card wrapper and apply a unique animation
    projectCardWrapperOne.forEach((projectCardWrapperOne) => {
        // Create a timeline
        let projectCardsTimeline = gsap.timeline({
            scrollTrigger: {
            trigger: projectCardWrapperOne,
            start: "top center",
            },
        });
        
        // Set initial position for each card
        projectCardsTimeline.set(".projects-layout-one .image-large", { y: -200, x: -200, opacity: 0 });
        projectCardsTimeline.set(".projects-layout-one .image-small-one", { y: -200, x: 200, opacity: 0 });
        projectCardsTimeline.set(".projects-layout-one .image-small-two", { y:-200, x: 200, opacity: 0 });
        projectCardsTimeline.set(".projects-layout-one .image-medium", { y: 200, x: -200, opacity: 0 });
        
        // Animate each card to its final position
        projectCardsTimeline.to(".projects-layout-one .image-large", {
            y: 0,
            x:0,
            opacity: 1,
            duration: 0.8,
        });
        projectCardsTimeline.to(".projects-layout-one .image-small-one", {
            y: 0,
            x:0,
            opacity: 1,
            duration: 0.8,
        }, "-=0.4");
        projectCardsTimeline.to(".projects-layout-one .image-small-two", {
            y: 0,
            x:0,
            opacity: 1,
            duration: 0.8,
        }, "-=0.4");
        projectCardsTimeline.to(".projects-layout-one .image-medium", {
            y: 0,
            x:0,
            opacity: 1,
            duration: 0.8,
        }, "-=0.4");
    });
    const projectCardWrapperTwo = document.querySelectorAll('.projects-layout-two .masonry-projects');
    // loop through each project card wrapper and apply a unique animation
    projectCardWrapperTwo.forEach((projectCardWrapperTwo) => {
        // Create a timeline
        let projectCardsTimelineTwo = gsap.timeline({
            scrollTrigger: {
            trigger: projectCardWrapperTwo,
            start: "top center",
            },
        });
        
        // Set initial position for each card
        projectCardsTimelineTwo.set(".projects-layout-two .image-small-one", { y: 200, opacity: 0 });
        projectCardsTimelineTwo.set(".projects-layout-two .image-medium", { y: -200, opacity: 0 });
        projectCardsTimelineTwo.set(".projects-layout-two .image-large", { x: -200, opacity: 0 });
        projectCardsTimelineTwo.set(".projects-layout-two .image-small-two", { x: 200, opacity: 0 });
        
        // Animate each card to its final position
        projectCardsTimelineTwo.to(".projects-layout-two .image-small-one", {
            y: 0,
            opacity: 1,
            duration: 0.8,
        });
        projectCardsTimelineTwo.to(".projects-layout-two .image-medium", {
            y: 0,
            opacity: 1,
            duration: 0.8,
        }, "-=0.4");
        projectCardsTimelineTwo.to(".projects-layout-two .image-large", {
            x: 0,
            opacity: 1,
            duration: 0.8,
        }, "-=0.4");
        projectCardsTimelineTwo.to(".projects-layout-two .image-small-two", {
            x: 0,
            opacity: 1,
            duration: 0.8,
        }, "-=0.4");
    });

    //Project List
    /*if (document.querySelector('.page-template-page-project-list')) {

        var top = $('.project-ajax-list').position().top; 

        if ($(window).width() > 768) {
            var start = "-" + top + " center";
        } else {
            var start = "-" + top + " center";
        }

        // Set up animation timeline
        let gridTl = gsap.timeline({
          scrollTrigger: {
            trigger: ".project-ajax-list",
            scrub: 1,
            start: start,
            end: "bottom-=50% bottom",
            once: true
          },
          defaults: {
            ease: "power1.inOut"
          }
        });
      
        // Wrap everything in a container with class `project-grid`
        const projectList = document.querySelector('.project-ajax-list');
        const projectGrid = document.createElement('div');
        projectGrid.classList.add('project-grid');
        projectList.parentNode.insertBefore(projectGrid, projectList);
        projectGrid.appendChild(projectList);
      
        // Add animations to the timeline
        gridTl.add("start")
            .from(".project-list", {
                ease: "power1",
                scale: 3,
                transformOrigin: "50% 0%", // Set the transform-origin to center horizontally but aligned to the top
            }, "start")
            .from(".project-card:nth-child(3n+1)", {
                duration: 0.6,
                xPercent: i => -((Math.floor(i / 3) + 1) * 40 + Math.floor(i / 3) * 100),
                yPercent: i => (Math.floor(i / 3) + 1) * 40 + Math.floor(i / 3) * 100
            }, "start")
            .from(".project-card:nth-child(3n+3)", {
                duration: 0.6,
                xPercent: i => ((Math.floor(i / 3) + 1) * 40 + Math.floor(i / 3) * 100),
                yPercent: i => (Math.floor(i / 3) + 1) * 40 + Math.floor(i / 3) * 100
            }, "start");
    }*/

     //Single Market
    /*if (document.querySelector('.single-market')) {

        var top = $('.project-list').position().top; 

        if ($(window).width() > 768) {
            var start = "-" + top + " center";
        } else {
            var start = "-" + top + " center";
        }

        // Set up animation timeline
    
        let gridTl = gsap.timeline({
        scrollTrigger: {
            trigger: ".project-list-content",
            scrub: 1,
            start: start,
            end: "center-=50%",
            once: true
        },
        defaults: {
            ease: "power1.inOut"
        }
        });
      
      
        // Wrap everything in a container with class `project-grid`
        const projectList = document.querySelector('.project-list-content');
        const projectGrid = document.createElement('div');
        projectGrid.classList.add('project-grid');
        projectList.parentNode.insertBefore(projectGrid, projectList);
        projectGrid.appendChild(projectList);
      
        // Add animations to the timeline
        gridTl.add("start")
            .from(".project-list", {
                ease: "power1",
                scale: 3,
                transformOrigin: "50% 0%", // Set the transform-origin to center horizontally but aligned to the top
            }, "start")
            .from(".project-card:nth-child(3n+1)", {
                duration: 0.6,
                xPercent: i => -((Math.floor(i / 3) + 1) * 40 + Math.floor(i / 3) * 100),
                yPercent: i => (Math.floor(i / 3) + 1) * 40 + Math.floor(i / 3) * 100
            }, "start")
            .from(".project-card:nth-child(3n+3)", {
                duration: 0.6,
                xPercent: i => ((Math.floor(i / 3) + 1) * 40 + Math.floor(i / 3) * 100),
                yPercent: i => (Math.floor(i / 3) + 1) * 40 + Math.floor(i / 3) * 100
            }, "start");
    }*/


    

    //careers
    if (document.querySelector('body.page-template-page-career-list')) {

        //Cards
        // Target all the callout cards
        // const cards = document.querySelectorAll('.callout-card');
      
        // // Set up the animation
        // const tl = gsap.timeline({ defaults: { ease: 'power2.inOut' } })
        //   .from(cards, { opacity: 0, y: 50, stagger: 0.2 })
        //   .to(cards, { y: 0, duration: 0.3 }, '+=0.5');
      
        // Add mousemove interaction
        // const mouse = { x: 0, y: 0 };
        // window.addEventListener('mousemove', e => {
        //   mouse.x = e.clientX;
        //   mouse.y = e.clientY;
        // });
      
        // cards.forEach(card => {
        //   card.addEventListener('mouseover', () => {
        //     gsap.to(card, { x: 0, y: 0, duration: 0.3 });
        //   });
        //   card.addEventListener('mouseleave', () => {
        //     gsap.to(card, { x: 0, y: 0, duration: 0.3 });
        //   });
        // });
      
        // gsap.ticker.add(() => {
        //   cards.forEach(card => {
        //     const cardRect = card.getBoundingClientRect();
        //     const cardCenterX = cardRect.left + (cardRect.width / 2);
        //     const cardCenterY = cardRect.top + (cardRect.height / 2);
        //     const dx = mouse.x - cardCenterX;
        //     const dy = mouse.y - cardCenterY;
        //     const dist = Math.sqrt(dx * dx + dy * dy);
        //     const intensity = Math.min(1, 1 / (dist / 100));
        //     const x = dx * intensity * 0.05;
        //     const y = dy * intensity * 0.05;
        //     if (card.matches(':hover')) {
        //       gsap.to(card, { x, y, duration: 0.3 });
        //     } else {
        //       gsap.to(card, { x: 0, y: 0, duration: 0.3 });
        //     }
        //   });
        // });
       
        //Positions 

        var tlPos = gsap.timeline({
            scrollTrigger: {
                trigger: ".open-positions .header",
                start: '-100% bottom',
                end: 'bottom center',
            }
        });

        // Define the variables
        var h4Elem = document.querySelector(".open-positions .header h4");
        var beforeBorderH4 = getComputedStyle(h4Elem, "::before");
        var contentWrapElem = document.querySelector(".open-positions .header .content-wrap");

        // Add the animation steps to the timeline
        tlPos
        .from(h4Elem, {
            '--border-height': '0',
            duration: parseFloat(beforeBorderH4.getPropertyValue('--border-duration')),
            ease: 'power3.in',
            onUpdate: function() {
                h4Elem.style.setProperty('--border-height', h4Elem.style.getPropertyValue('--border-height'));
            }
        })
        .to(h4Elem, {
            duration: .5,
            ease: 'power3.out',
            opacity: 1,
            x: 0,
        })
        .to(h4Elem, {
            '--border-height': '100%',
            duration: parseFloat(beforeBorderH4.getPropertyValue('--border-duration')),
            ease: 'power3.out',
            onUpdate: function() {
                h4Elem.style.setProperty('--border-height', h4Elem.style.getPropertyValue('--border-height'));
            }
        })
        .from(contentWrapElem, {
            duration: .25,
            ease: 'power3.out',
            opacity: 0,
            y: 100,
        });

        //Posotion Cards
        ScrollTrigger.batch(".positions .career-cards .career", {
            onEnter: elements => {
              gsap.from(elements, {
                autoAlpha: 0,
                y: 60,
                stagger: 0.15,
                delay: 0.5 // Add a delay of 0.5 seconds
              });
            },
            once: true
        });
    }
    

    //Markets
    if (document.querySelector('body.market-template-default')) {
        ScrollTrigger.batch(".project-list .project-card", {
            onEnter: elements => {
              gsap.from(elements, {
                autoAlpha: 0,
                y: 60,
                stagger: 0.15
              });
            },
            once: true
        });
        
    }
    

    //Projects
    if (document.querySelector('body.page-template-page-project-list')) {
        ScrollTrigger.batch(".project-list .project-card", {
            onEnter: elements => {
              gsap.from(elements, {
                autoAlpha: 0,
                y: 60,
                stagger: 0.15
              });
            },
            once: true
        });
        
    }


    //Insights
    if (document.querySelector('body.page-template-page-insights-list')) {
        ScrollTrigger.batch(".insight-list .insight-card", {
            onEnter: elements => {
              gsap.from(elements, {
                autoAlpha: 0,
                y: 60,
                stagger: 0.15
              });
            },
            once: true
        });
        
    }

    // $( ".menu-item a, .site-branding a" ).on( "click", function() {
    //     destLoc = $(this).attr('href');
    //     currLoc = $(location).attr('href');


    
    // });

     

    $(document).on("click", "a[href^='http']" + "a[target!='_blank']" + "a:not(.page-numbers)", function (e) {// Listen for all link click events on the page (assuming other scripts don’t stop them from bubbling all the way up)
        // Stop the link from being followed.
        e.preventDefault();
        var destLoc = $(this).attr('href');
        var currLoc = $(location).attr('href');

        if (currLoc != destLoc) {
            window.setTimeout(function () {
                window.location = destLoc;
            }, 200);

            $('.wiper-shade.color').addClass('animate');
            setTimeout(function() {
                $('.wiper-shade.white').addClass('animate');
            }, 200);  

        } else {
            $('.wiper-shade').removeClass('animate');
        }
        return false;
    });



});


/* If browser back button was used, flush cache */
(function () {
	window.onpageshow = function(event) {
		if (event.persisted) {
			window.location.reload();
		}
	};
})();